module.exports = __webpack_public_path__ + "img/excel.c4b0f833.png";